var _dec, _class, _Body;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component, Children, isValidElement } from 'react';
import { safeCloneElement, omitProps } from '@instructure/ui-react-utils';
import { View } from '@instructure/ui-view';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';
import TableContext from '../TableContext';

/**
---
parent: Table
id: Table.Body
---
**/
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
let Body = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_Body = class Body extends Component {
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    const _this$props3 = this.props,
      children = _this$props3.children,
      styles = _this$props3.styles;
    const _this$context = this.context,
      isStacked = _this$context.isStacked,
      hover = _this$context.hover,
      headers = _this$context.headers;
    return _jsx(View, {
      ...View.omitViewProps(omitProps(this.props, Body.allowedProps), Body),
      as: isStacked ? 'div' : 'tbody',
      css: styles === null || styles === void 0 ? void 0 : styles.body,
      role: isStacked ? 'rowgroup' : void 0,
      children: Children.map(children, child => {
        if (/*#__PURE__*/isValidElement(child)) {
          return safeCloneElement(child, {
            key: child.props.name,
            // Sent down for compatibility with custom components
            // TODO DEPRECATED, remove in v11
            hover,
            // Sent down for compatibility with custom components
            // TODO DEPRECATED, remove in v11
            isStacked,
            // Sent down for compatibility with custom components
            // TODO DEPRECATED, remove in v11
            headers
          });
        }
        return child;
      })
    });
  }
}, _Body.displayName = "Body", _Body.componentId = 'Table.Body', _Body.contextType = TableContext, _Body.allowedProps = allowedProps, _Body.propTypes = propTypes, _Body.defaultProps = {
  children: null
}, _Body)) || _class);
export default Body;
export { Body };